import { render, staticRenderFns } from "./NewiqcTestsheet.vue?vue&type=template&id=c4686124"
import script from "./NewiqcTestsheet.vue?vue&type=script&lang=js"
export * from "./NewiqcTestsheet.vue?vue&type=script&lang=js"
import style0 from "./NewiqcTestsheet.vue?vue&type=style&index=0&id=c4686124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports